export default [
    {
        name: 'prAll',
        path: 'prAll',
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/prAll'),
        meta: { title: '全部' },
        props(route) {
            return {id: route.query.id}
        },
    },
    {
        name: 'prSettling',
        path: 'prSettling',
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/prSettling'),
        meta: { title: '结算中' },
        props(route) {
            return {id: route.query.id}
        },
    },
    {
        name: 'prPendingPayment',
        path: 'prPendingPayment',
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/prPendingPayment'),
        meta: { title: '待缴费' },
        props(route) {
            return {id: route.query.id}
        },
    },
    {
        name: 'prPaying',
        path: 'prPaying',
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/prPaying'),
        meta: { title: '正在缴费' },
        props(route) {
            return {id: route.query.id}
        },
    },
    {
        name: 'prPaid',
        path: 'prPaid',
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/prPaid'),
        meta: { title: '已缴费' },
        props(route) {
            return {id: route.query.id}
        },
    },
]